// Timeline.tsx
import { useEffect, useState } from 'react';
import "./chat-timeline.component.scss";
import { convertSecondsToHHMMSS } from '../../../utility/function.utility';
import { Transcript } from '../../../model/transcript-log.model';
import Bar from './bar/bar.component';

const parseTime = (time: string) => {
    const parts = convertSecondsToHHMMSS(time).split(':').map(parseFloat);
    const totalPart = parts[0] * 3600 + parts[1] * 60 + parts[2];
    return totalPart;
};

const ChatTimelineComponent = ({ transcriptList }: any) => {

    const [transcripts, setTranscripts] = useState<any>([]);
    const [totalDuration, setTotalDuration] = useState<number>(0);

    useEffect(() => {
        setTranscripts(groupBySpeaker(transcriptList));
        setTotalDuration(transcriptList[transcriptList.length - 1].end_time);
    }, []);

    function groupBySpeaker(transcripts: Transcript[]) {
        const groupedData = new Map();

        transcripts.forEach(item => {
            if (!groupedData.has(item.role)) {
                groupedData.set(item.role, []);
            }

            groupedData.get(item.role).push({
                duration: item.duration,
                end_time: item.end_time,
                role: item.role,
                start_time: item.start_time,
                text: item.text
            });
        });

        return Array.from(groupedData, ([role, transcripts]) => ({ role, transcripts }));
    }

    return (
        <>
            {
                transcripts && transcripts.map((group, groupIndex) => {
                    const maxTimeForGroup = convertSecondsToHHMMSS(totalDuration + "");
                    const speakerClass = `speaker-${(groupIndex % 5) + 1}`;

                    return (
                        <div key={groupIndex} className="wave-timeline-item-control">
                            <p className={`wave-name-agent ${speakerClass}`}>
                                {group.role.replace('Speaker', 'ผู้พูด')}
                            </p>

                            <div className="wave-timeline-control">
                                {
                                    group.transcripts.map((segment, segmentIndex) => (
                                        <Bar
                                            key={segmentIndex}
                                            role={segment.role}
                                            customClass={speakerClass}
                                            durationPercentage={(parseTime(segment.duration) / totalDuration) * 100}
                                            startTimePercentage={(parseTime(segment.start_time) / totalDuration) * 100}
                                        />
                                    ))
                                }
                            </div>

                            <div className={`wave-minute-control ${speakerClass}`}>
                                <span className="wave-text-time">00:00:00</span>
                                <span className="wave-text-time">{maxTimeForGroup}</span>
                            </div>
                        </div>
                    )
                })
            }
        </>
    );
};

export default ChatTimelineComponent;
